export default {
  provide() {
    return {
      loginUserInfo: () => this.loginUserInfo,
    };
  },
  data() {
    return {
      loginUserInfo: {},
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    /**
     * 当前登录用户信息
     */
    async getUserInfo() {
      try {
        const userInfo = await this.$utils.sgApi.getSession();
        const { Avatar, UserId, UserName } = userInfo.CurUserForWebUI;
        const { headImg } = userInfo.CustInfomationVMSG;
        this.loginUserInfo = {
          avatar: Avatar || headImg,
          userId: UserId,
          userName: UserName,
        };
      } catch (error) {
        console.log(error);
      }
    },
  },
};
